const ar = {
  common: {
    appName: "زاد المسلم",
    download: "تحميل التطبيق",
    googlePlay: "حمّل من Google Play",
    menu: "القائمة",
    lightMode: "الوضع الفاتح",
    darkMode: "الوضع الداكن",
    enableLight: "تفعيل الوضع الفاتح",
    enableDark: "تفعيل الوضع الداكن",
    switchLanguage: "Switch to English",
    languageLabel: "English",
    languageShort: "EN",
  },
  nav: {
    features: "المزايا",
    screenshots: "صور التطبيق",
    why: "لماذا زاد المسلم",
    privacy: "الخصوصية",
    github: "المساهمة",
    faq: "الأسئلة الشائعة",
  },
  hero: {
    titleBefore: "كل ما يحتاجه",
    titleAccent: "المسلم",
    titleAfter: "في مكان واحد",
    description:
      "زاد المسلم يجمع بين القرآن الكريم، مواقيت الصلاة، الأذكار، السنة النبوية، واتجاه القبلة في تجربة واحدة صُممت لترافقك في كل لحظة من يومك",
    cta: "حمّل التطبيق الآن مجانًا",
    availability: "متاح لأجهزة Android وقريبًا على iOS",
    nextPrayer: "الصلاة القادمة",
    prayer: "العصر · 04:41",
    activeReciter: "قارئ نشط الآن",
    reciter: "مشاري العفاسي",
    imageAlt: "تطبيق زاد المسلم",
  },
  stats: [
    { number: "5", label: "كتب تفسير" },
    { number: "7,563", label: "حديثًا" },
    { number: "+30", label: "قارئًا" },
    { number: "5", label: "إصدارات" },
    { number: "+100", label: "مستخدمًا" },
  ],
  intro: {
    label: "عن التطبيق",
    before: "زاد المسلم يجمع بين",
    highlight:
      "القرآن الكريم، مواقيت الصلاة، الأذكار، السنة النبوية، واتجاه القبلة",
    after: "في تجربة واحدة صُممت لترافقك في كل لحظة من يومك. استمع إلى أكثر من",
    readers: "30 قارئًا",
    offlineBefore: "، وحمّل السور أو المصحف كاملًا للاستماع",
    offline: "دون إنترنت",
    rest: "، وتابع قراءتك من حيث توقفت بلمسة واحدة. احصل على مواقيت صلاة دقيقة مع تنبيهات الأذان والعد التنازلي للصلاة القادمة، واستفد من الأذكار اليومية وحصن المسلم، وتصفح الأحاديث النبوية بسهولة، مع بوصلة دقيقة لتحديد اتجاه القبلة، والتاريخين الهجري والميلادي، وتشغيل التلاوات في الخلفية مع التحكم بها مباشرة من الإشعارات وشاشة القفل.",
  },
  features: {
    label: "المزايا",
    title: "كل ما تحتاجه في مكان واحد",
    items: [
      {
        title: "القرآن الكريم",
        desc: "قراءة المصحف، متابعة موضع القراءة تلقائيًا، والاستماع لأكثر من 30 قارئًا.",
      },
      {
        title: "التفاسير",
        desc: "الوصول إلى خمسة كتب تفسير متاحة داخل التطبيق.",
      },
      {
        title: "مواقيت الصلاة",
        desc: "مواقيت دقيقة، تنبيهات الأذان، وعد تنازلي للصلاة القادمة.",
      },
      {
        title: "الأحاديث النبوية",
        desc: "تصفح 7,563 حديثًا بطريقة منظمة وسهلة.",
      },
      {
        title: "الأذكار وحصن المسلم",
        desc: "أذكار يومية ومحتوى مناسب لمختلف أوقات اليوم.",
      },
      {
        title: "اتجاه القبلة",
        desc: "بوصلة لتحديد اتجاه القبلة اعتمادًا على موقعك.",
      },
      {
        title: "التلاوات الصوتية",
        desc: "تشغيل في الخلفية والتحكم مباشرة من الإشعارات وشاشة القفل.",
      },
      {
        title: "العمل دون إنترنت",
        desc: "معظم أجزاء التطبيق متاحة دون إنترنت بعد تنزيل المحتوى.",
      },
    ],
  },
  screenshots: {
    label: "لمحة من الداخل",
    title: "شكل التطبيق",
    items: [
      "الصفحة الرئيسية",
      "مواقيت الصلاة",
      "القرآن الكريم",
      "الأحاديث",
      "القرآن المرتل والصوتيات",
      "اتجاه القبلة",
      "الإعدادات",
    ],
  },
  why: {
    label: "لماذا زاد المسلم؟",
    title: "مبني على الثقة والبساطة",
    items: [
      { title: "مجاني بالكامل", desc: "بدون أي رسوم أو اشتراكات." },
      { title: "بدون إعلانات", desc: "تجربة نظيفة من أول لحظة." },
      { title: "خصوصيتك محفوظة", desc: "لا نجمع أي بيانات عن المستخدمين." },
      { title: "يعمل دون إنترنت", desc: "معظم الأقسام متاحة بدون اتصال." },
      { title: "مفتوح المصدر", desc: "الكود متاح للجميع على GitHub." },
    ],
  },
  mission: {
    label: "رسالتنا",
    text: "زاد المسلم لم يُصمم كمشروع تجاري، بل كخطوة بسيطة لخدمة المسلمين في يومهم. لا إعلانات، لا مقابل مادي، فقط تطبيق يسعى لأن يكون رفيقًا صادقًا في رحلتك اليومية مع القرآن والصلاة والذكر.",
  },
  privacy: {
    label: "الخصوصية والأذونات",
    title: "نحن نحترم خصوصيتك",
    items: [
      "لا يجمع التطبيق أي بيانات عن المستخدمين.",
      "إذن الموقع يُستخدم فقط لحساب مواقيت الصلاة وتحديد اتجاه القبلة.",
      "الإنترنت مطلوب مرة واحدة لجلب مدينتك، وبعدها تعمل المواقيت محليًا.",
      "الإنترنت مطلوب أيضًا عند تنزيل التفاسير أو تحميل التلاوات للاستماع دون اتصال.",
      "معظم أقسام التطبيق تعمل بالكامل دون إنترنت.",
    ],
  },
  github: {
    label: "مفتوح المصدر",
    title: "شارك في تطوير زاد المسلم",
    cardTitle: "مشروع مفتوح المصدر بالكامل",
    description:
      "يمكنك الاطلاع على الكود، اقتراح تحسينات، أو المساهمة مباشرة في تطوير التطبيق عبر GitHub.",
    cta: "زيارة المستودع",
  },
  faq: {
    label: "الأسئلة الشائعة",
    title: "لديك سؤال؟",
    items: [
      { q: "هل التطبيق مجاني؟", a: "نعم، التطبيق مجاني بالكامل." },
      {
        q: "هل يحتوي على إعلانات؟",
        a: "لا، التطبيق خالٍ تمامًا من الإعلانات.",
      },
      {
        q: "هل يعمل دون إنترنت؟",
        a: "يعمل جزء كبير من التطبيق دون إنترنت، بينما تتطلب بعض العمليات مثل تنزيل التفاسير والتلاوات اتصالًا بالإنترنت.",
      },
      {
        q: "لماذا يحتاج التطبيق إلى تحديد الموقع؟",
        a: "لاستخدامه في حساب مواقيت الصلاة وتحديد اتجاه القبلة فقط.",
      },
      {
        q: "هل يجمع بيانات المستخدمين؟",
        a: "لا، التطبيق لا يجمع أي بيانات عن المستخدمين.",
      },
      {
        q: "هل التطبيق متوفر على iPhone؟",
        a: "غير متوفر حاليًا، ومن المخطط طرح نسخة على App Store مستقبلًا.",
      },
      {
        q: "كيف يمكنني الإبلاغ عن مشكلة؟",
        a: "عبر مراسلة المطور من صفحة التطبيق في المتجر، أو إنشاء Issue في مستودع GitHub.",
      },
    ],
  },
  download: {
    label: "ابدأ الآن",
    title: "زادك اليومي على بُعد تحميل واحد",
    description:
      "انضم إلى مستخدمي زاد المسلم، وابدأ رحلتك مع القرآن والذكر والصلاة اليوم.",
    qrAlt: "امسح لتحميل زاد المسلم",
    qrCaption: "امسح للتحميل المباشر",
  },
  footer: {
    description:
      "تطبيق يجمع بين القرآن الكريم والأذكار ومواقيت الصلاة واتجاه القبلة في مكان واحد، مع احترام كامل لخصوصيتك.",
    soon: "قريبًا",
    links: "روابط",
    privacy: "سياسة الخصوصية",
    terms: "شروط الاستخدام",
    contact: "تواصل",
    copyright: "© 2026 زاد المسلم. جميع الحقوق محفوظة.",
  },
};

const en = {
  common: {
    appName: "Zad Al-Muslim",
    download: "Download App",
    googlePlay: "Get it on Google Play",
    menu: "Menu",
    lightMode: "Light mode",
    darkMode: "Dark mode",
    enableLight: "Enable light mode",
    enableDark: "Enable dark mode",
    switchLanguage: "التبديل إلى العربية",
    languageLabel: "العربية",
    languageShort: "ع",
  },
  nav: {
    features: "Features",
    screenshots: "Screenshots",
    why: "Why Zad",
    privacy: "Privacy",
    github: "Contribute",
    faq: "FAQ",
  },
  hero: {
    titleBefore: "Everything",
    titleAccent: "a Muslim needs",
    titleAfter: "in one place",
    description:
      "Zad Al-Muslim brings the Quran, prayer times, daily adhkar, the Prophetic Sunnah, and Qibla direction together in one experience designed to accompany you throughout your day.",
    cta: "Download the app for free",
    availability: "Available on Android, coming soon to iOS",
    nextPrayer: "Next prayer",
    prayer: "Asr · 04:41",
    activeReciter: "Now playing",
    reciter: "Mishary Alafasy",
    imageAlt: "Zad Al-Muslim app",
  },
  stats: [
    { number: "5", label: "Tafsir books" },
    { number: "7,563", label: "Hadiths" },
    { number: "+30", label: "Reciters" },
    { number: "5", label: "Releases" },
    { number: "+100", label: "Users" },
  ],
  intro: {
    label: "About the app",
    before: "Zad Al-Muslim brings together",
    highlight:
      "the Quran, prayer times, adhkar, the Prophetic Sunnah, and Qibla direction",
    after:
      "in one experience designed for every moment of your day. Listen to more than",
    readers: "30 reciters",
    offlineBefore:
      ", download individual surahs or the complete Quran and listen",
    offline: "offline",
    rest: ", and resume reading exactly where you stopped. Get accurate prayer times, adhan alerts, and a countdown to the next prayer; access daily adhkar and Hisn Al-Muslim; browse hadiths easily; find the Qibla with a precise compass; view Hijri and Gregorian dates; and control background recitation from notifications and the lock screen.",
  },
  features: {
    label: "Features",
    title: "Everything you need in one place",
    items: [
      {
        title: "The Holy Quran",
        desc: "Read the Quran, automatically save your place, and listen to over 30 reciters.",
      },
      {
        title: "Tafsir",
        desc: "Access five books of Quran commentary inside the app.",
      },
      {
        title: "Prayer Times",
        desc: "Accurate times, adhan notifications, and a countdown to the next prayer.",
      },
      {
        title: "Prophetic Hadith",
        desc: "Browse 7,563 hadiths in a clear, organized way.",
      },
      {
        title: "Adhkar & Hisn Al-Muslim",
        desc: "Daily remembrance suited to every part of your day.",
      },
      {
        title: "Qibla Direction",
        desc: "Find the Qibla using a compass based on your location.",
      },
      {
        title: "Audio Recitations",
        desc: "Play in the background and control audio from notifications and the lock screen.",
      },
      {
        title: "Works Offline",
        desc: "Most of the app remains available offline after content is downloaded.",
      },
    ],
  },
  screenshots: {
    label: "A look inside",
    title: "Explore the app",
    items: [
      "Home",
      "Prayer times",
      "The Holy Quran",
      "Hadith",
      "Recitations and audio",
      "Qibla direction",
      "Settings",
    ],
  },
  why: {
    label: "Why Zad Al-Muslim?",
    title: "Built on trust and simplicity",
    items: [
      { title: "Completely free", desc: "No fees or subscriptions." },
      { title: "Ad-free", desc: "A clean experience from the start." },
      { title: "Privacy-first", desc: "We do not collect user data." },
      {
        title: "Works offline",
        desc: "Most sections work without a connection.",
      },
      { title: "Open source", desc: "The source code is available on GitHub." },
    ],
  },
  mission: {
    label: "Our mission",
    text: "Zad Al-Muslim was not built as a commercial project, but as a simple way to serve Muslims in their daily lives. No ads and no fees—just an app that strives to be a faithful companion on your daily journey with the Quran, prayer, and remembrance.",
  },
  privacy: {
    label: "Privacy & permissions",
    title: "We respect your privacy",
    items: [
      "The app does not collect any user data.",
      "Location permission is used only to calculate prayer times and determine the Qibla direction.",
      "Internet access is needed once to find your city; prayer times then work locally.",
      "Internet access is also required to download tafsir books or recitations for offline listening.",
      "Most sections of the app work completely offline.",
    ],
  },
  github: {
    label: "Open source",
    title: "Help build Zad Al-Muslim",
    cardTitle: "A fully open-source project",
    description:
      "Explore the code, suggest improvements, or contribute directly to the app on GitHub.",
    cta: "View repository",
  },
  faq: {
    label: "Frequently asked questions",
    title: "Have a question?",
    items: [
      { q: "Is the app free?", a: "Yes, the app is completely free." },
      { q: "Does it contain ads?", a: "No, the app is entirely ad-free." },
      {
        q: "Does it work offline?",
        a: "A large part of the app works offline. Some actions, such as downloading tafsir books and recitations, require an internet connection.",
      },
      {
        q: "Why does the app need my location?",
        a: "It is used only to calculate prayer times and determine the Qibla direction.",
      },
      {
        q: "Does the app collect user data?",
        a: "No, the app does not collect any user data.",
      },
      {
        q: "Is the app available on iPhone?",
        a: "Not yet. An App Store release is planned for the future.",
      },
      {
        q: "How can I report an issue?",
        a: "Contact the developer through the store listing or open an issue in the GitHub repository.",
      },
    ],
  },
  download: {
    label: "Get started",
    title: "Your daily companion is one download away",
    description:
      "Join Zad Al-Muslim users and begin your journey with the Quran, remembrance, and prayer today.",
    qrAlt: "Scan to download Zad Al-Muslim",
    qrCaption: "Scan for direct download",
  },
  footer: {
    description:
      "An all-in-one app for the Quran, adhkar, prayer times, and Qibla direction, built with full respect for your privacy.",
    soon: "Coming soon",
    links: "Links",
    privacy: "Privacy Policy",
    terms: "Terms of Use",
    contact: "Contact",
    copyright: "© 2026 Zad Al-Muslim. All rights reserved.",
  },
};

export const translations = { ar, en };
